import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n'
import app from './modules/app'
import ebooking from './modules/ebooking'
import countries from './modules/countries'
import configurations from './modules/configurations'
import zones from './modules/zones'
import servers from './modules/servers'
import common from './modules/common'
import leadsModule from './modules/leads'
import homelabModule from './modules/homelab'
import authModule from './modules/auth'
import ranuModule from './modules/ranu'
import leadsWebModule from './modules/leads-web'
import virtualWaitingRoom from "./modules/virtualWaitingRoom";
import wellbeing from "./modules/wellbeing"
import { state } from './state'
import { actions } from './actions'
import { mutations } from './mutations'
import { getters } from './getters'
import iframeModule from './modules/iframe'
import checkup from "./modules/checkup"

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  modules: {
    leads: leadsModule,
    auth: authModule,
    homelab: homelabModule,
    app,
    configurations,
    common,
    ebooking,
    countries,
    zones,
    servers,
    ranu: ranuModule,
    leadsWeb: leadsWebModule,
    iframe: iframeModule,
    virtualWaitingRoom: virtualWaitingRoom,
    wellbeing: wellbeing,
    checkup: checkup
  },
  state,
  mutations,
  actions,
  getters,
})

Vue.use(VuexI18n.plugin, store)

export default store
